export default __webpack_public_path__ + "static/media/profile-large.3359565f.jpg";